import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { GTAG_CODE } from "../../constants";
import { useCookieConsent } from "../cookieConsent";

export const AnalyticsTracker = () => {
  const location = useLocation();
  const { analyticsConsent } = useCookieConsent();

  useEffect(() => {
    if (analyticsConsent === "granted") {
      window.dataLayer = window.dataLayer || [];
      window.gtag =
        window.gtag || function gtag() {
          window.dataLayer.push(arguments);
        };
      window.gtag("config", GTAG_CODE, {
        page_path: location.pathname + location.hash + location.search,
      });
    }
  }, [analyticsConsent, location]);

  return null;
};
